import { exportElementToPdf } from './exportElementToPdf'

/**
 * Gera PDF A4 do template de orçamento (elemento já renderizado).
 * Quebra páginas nas linhas da tabela, sem repetir fatias nem folha em branco.
 */
export async function exportQuoteElementToPdf(element, filename) {
  await exportElementToPdf(element, filename, {
    orientation: 'p',
    scale: 2,
    jpegQuality: 0.92,
    rowSelector: '.order-pdf-table tbody tr',
    summarySelector: '.order-pdf-summary',
  })
}
